import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [completed, setCompleted] = useState({});
  const [currentTopic, setCurrentTopic] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("rnProgress");
    if (saved) {
      setCompleted(JSON.parse(saved));
    }
  }, []);

  const saveProgress = (updatedCompleted) => {
    localStorage.setItem("rnProgress", JSON.stringify(updatedCompleted));
    setCompleted(updatedCompleted);
  };

  const toggleComplete = (topicId) => {
    const updated = { ...completed, [topicId]: !completed[topicId] };
    saveProgress(updated);
  };

  const TOPICS = [
    {
      id: 1,
      title: "What is React Native?",
      videoId: "gvkqT_Uoahw",
      section: "Fundamentals",
      level: "Beginner",
      duration: "12 min",
      content: "react-native-intro",
      isGuide: true,
    },
    {
      id: 2,
      title: "What is Expo?",
      videoId: "vFW_TxKLyrE",
      section: "Fundamentals",
      level: "Beginner",
      duration: "10 min",
      content: "expo-intro",
      isGuide: true,
    },
    {
      id: 3,
      title: "Expo vs CLI",
      videoId: "OjYF5-eFGsQ",
      section: "Fundamentals",
      level: "Beginner",
      duration: "15 min",
      content: "expo-vs-cli",
      isGuide: true,
    },
    {
      id: 4,
      title: "Project Structure",
      videoId: "PjmAVh4Syvk",
      section: "Fundamentals",
      level: "Beginner",
      duration: "14 min",
      content: "project-structure",
      isGuide: true,
    },
    {
      id: 5,
      title: "React Native Components",
      videoId: "g62qiUJe35c",
      section: "Core Components",
      level: "Beginner",
      duration: "18 min",
      content: "rn-components",
      isGuide: true,
    },
    {
      id: 6,
      title: "ScrollView",
      videoId: "h3GRIsUQP3M",
      section: "Core Components",
      level: "Intermediate",
      duration: "13 min",
      content: "scrollview",
      isGuide: true,
    },
    {
      id: 7,
      title: "FlatList",
      videoId: "lYgiIlLIFGs",
      section: "Core Components",
      level: "Intermediate",
      duration: "16 min",
      content: "flatlist",
      isGuide: true,
    },
    {
      id: 8,
      title: "Button and Touchable",
      videoId: "0ZP4zzrVoRQ",
      section: "Core Components",
      level: "Intermediate",
      duration: "12 min",
      content: "buttons",
      isGuide: true,
    },
    {
      id: 9,
      title: "TextInput",
      videoId: "O24IM5H2nHY",
      section: "Forms & Input",
      level: "Intermediate",
      duration: "14 min",
      content: "textinput",
      isGuide: true,
    },
    {
      id: 10,
      title: "KeyboardAvoidingView",
      videoId: "_IIKUtvla58",
      section: "Forms & Input",
      level: "Intermediate",
      duration: "11 min",
      content: "keyboard-view",
      isGuide: true,
    },
    {
      id: 11,
      title: "Flexbox Layout",
      videoId: "MJ7P1JUyuFA",
      section: "Styling & Layout",
      level: "Intermediate",
      duration: "17 min",
      content: "flexbox",
      isGuide: true,
    },
    {
      id: 12,
      title: "SafeAreaView",
      videoId: "dQrR02uErnA",
      section: "Styling & Layout",
      level: "Intermediate",
      duration: "10 min",
      content: "safearea",
      isGuide: true,
    },
    {
      id: 13,
      title: "SafeArea vs StatusBar",
      videoId: "dQrR02uErnA",
      section: "Styling & Layout",
      level: "Intermediate",
      duration: "12 min",
      content: "safearea-statusbar",
      isGuide: true,
    },
    {
      id: 14,
      title: "StyleSheet",
      videoId: "9yhlhKX7ZYM",
      section: "Styling & Layout",
      level: "Intermediate",
      duration: "13 min",
      content: "stylesheet",
      isGuide: true,
    },
    {
      id: 15,
      title: "Navigation Basics",
      videoId: "c_7ukxJz1wE",
      section: "Navigation",
      level: "Advanced",
      duration: "15 min",
      content: "navigation-basics",
      isGuide: true,
    },
    {
      id: 16,
      title: "Stack Navigation",
      videoId: "ns6jYAWoeVo",
      section: "Navigation",
      level: "Advanced",
      duration: "18 min",
      content: "stack-navigation",
      isGuide: true,
    },
    {
      id: 17,
      title: "Drawer Navigation",
      videoId: "KRHdDGVrItw",
      section: "Navigation",
      level: "Advanced",
      duration: "16 min",
      content: "drawer-navigation",
      isGuide: true,
    },
    {
      id: 18,
      title: "Tab Navigation",
      videoId: "XiutL0uLICg",
      section: "Navigation",
      level: "Advanced",
      duration: "14 min",
      content: "tab-navigation",
      isGuide: true,
    },
    {
      id: 19,
      title: "UseFouceffect and Usecallback",
      // videoId: "8oOZ9lFt8W4",
      section: "Good use Cases",
      level: "Advanced",
      content: "UseFouceffect-and-Usecallback",
      isGuide: true,

    },
    {
      id: 20,
      title: "Passing Params",
       section: "Navigation",
      level: "Advanced",
      duration: "15 min",
      content: "Passing-Params",
      isGuide: true,
    },
  ];

  const filteredTopics = TOPICS.filter((t) =>
    t.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sections = {};
  filteredTopics.forEach((t) => {
    if (!sections[t.section]) sections[t.section] = [];
    sections[t.section].push(t);
  });

  const completedCount = Object.values(completed).filter(Boolean).length;
  const progressPercent = Math.round((completedCount / TOPICS.length) * 100);

  const currentTopicData = TOPICS[currentTopic];

  const GuideContent = ({ content }) => {
    switch (content) {
      case "react-native-intro":
        return (
          <div className="guide-section">
            <h2>What is React Native?</h2>
            <div className="guide-card">
              <h3>Overview</h3>
              <p>
                React Native is a JavaScript framework for building native mobile applications for iOS and Android platforms. It uses React (Facebook's UI library) and JavaScript to create mobile apps that feel and perform like native applications.
              </p>
            </div>

            <div className="guide-card">
              <h3>Key Features</h3>
              <ul>
                <li>📱 <strong>Learn Once, Write Anywhere</strong> - Write code once and deploy to multiple platforms</li>
                <li>⚡ <strong>Fast Performance</strong> - Uses native components, not WebViews</li>
                <li>🔄 <strong>Hot Reload</strong> - See changes instantly without rebuilding</li>
                <li>🎯 <strong>Component-Based</strong> - Build apps using reusable components</li>
                <li>🌐 <strong>Large Community</strong> - Huge ecosystem of libraries and tools</li>
                <li>💼 <strong>Industry Standard</strong> - Used by Facebook, Instagram, Airbnb, Uber</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>React Native vs Traditional Native Development</h3>
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th>Aspect</th>
                    <th>React Native</th>
                    <th>Native (Swift/Kotlin)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Language</td>
                    <td>JavaScript</td>
                    <td>Swift/Kotlin</td>
                  </tr>
                  <tr>
                    <td>Learning Curve</td>
                    <td>Easier (JS knowledge)</td>
                    <td>Steeper</td>
                  </tr>
                  <tr>
                    <td>Development Time</td>
                    <td>Faster</td>
                    <td>Slower</td>
                  </tr>
                  <tr>
                    <td>Code Reusability</td>
                    <td>High (iOS + Android)</td>
                    <td>Low (platform-specific)</td>
                  </tr>
                  <tr>
                    <td>Performance</td>
                    <td>Good</td>
                    <td>Better</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="guide-card">
              <h3>Prerequisites</h3>
              <ul>
                <li>✓ JavaScript knowledge</li>
                <li>✓ React basics understanding</li>
                <li>✓ Node.js installed</li>
                <li>✓ Terminal/Command line comfort</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>When to Use React Native</h3>
              <ul>
                <li>✅ Building cross-platform mobile apps</li>
                <li>✅ Rapid prototyping</li>
                <li>✅ Startup projects with limited resources</li>
                <li>✅ Teams with JavaScript expertise</li>
                <li>❌ High-performance graphics/games</li>
                <li>❌ Complex native integrations</li>
              </ul>
            </div>
          </div>
        );

      case "expo-intro":
        return (
          <div className="guide-section">
            <h2>What is Expo?</h2>
            <div className="guide-card">
              <h3>Overview</h3>
              <p>
                Expo is an open-source framework built on top of React Native that makes developing React Native apps easier and faster. It provides tools, services, and libraries that remove much of the complexity from React Native development.
              </p>
            </div>

            <div className="guide-card">
              <h3>What Expo Provides</h3>
              <ul>
                <li>📦 <strong>Pre-built Modules</strong> - Camera, location, notifications, sensors, etc.</li>
                <li>🚀 <strong>Expo Go App</strong> - Test your app instantly on physical devices</li>
                <li>☁️ <strong>Cloud Services</strong> - Build, deploy, and manage apps</li>
                <li>⚙️ <strong>Development Tools</strong> - Hot reload, debugging, and more</li>
                <li>📱 <strong>Over-the-Air Updates</strong> - Update your app without app store</li>
                <li>🎯 <strong>Easy Setup</strong> - No native code knowledge needed</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Installation & Setup</h3>
              <div className="code-block">
                <code>
                  {`# Install Expo CLI globally
npm install -g expo-cli

# Create new Expo project
expo init MyApp
cd MyApp

# Start the development server
npm start

# Or use expo command
expo start`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Expo Go App</h3>
              <p>
                Expo Go is a mobile app that lets you run Expo projects on your phone or tablet instantly. Just scan the QR code from your terminal after running `npm start`.
              </p>
              <p>Download from:</p>
              <ul>
                <li>📱 App Store (iOS)</li>
                <li>🤖 Google Play Store (Android)</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Advantages of Expo</h3>
              <ul>
                <li>✅ Fast development speed</li>
                <li>✅ No native code needed</li>
                <li>✅ Easy testing on real devices</li>
                <li>✅ Large library of pre-built modules</li>
                <li>✅ Great documentation</li>
                <li>✅ Perfect for beginners</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Limitations</h3>
              <ul>
                <li>⚠️ Can't use native modules easily</li>
                <li>⚠️ Larger app bundle size</li>
                <li>⚠️ Less control over native code</li>
              </ul>
            </div>
          </div>
        );

      case "expo-vs-cli":
        return (
          <div className="guide-section">
            <h2>Expo vs React Native CLI</h2>
            <div className="guide-card">
              <h3>What's the Difference?</h3>
              <p>
                Both are ways to build React Native apps, but they have different approaches:
              </p>
            </div>

            <div className="guide-card">
              <h3>Expo Approach</h3>
              <div className="code-block">
                <code>
                  {`# Simple setup
expo init MyApp
cd MyApp
npm start

# No native code needed
# Use Expo modules for everything
# Managed by Expo`}
                </code>
              </div>
              <p>✅ Easier for beginners<br/>✅ Faster development<br/>⚠️ Less control</p>
            </div>

            <div className="guide-card">
              <h3>React Native CLI Approach</h3>
              <div className="code-block">
                <code>
                  {`# More complex setup
npx react-native init MyApp
cd MyApp
npx react-native run-android
# or
npx react-native run-ios

# Need Android Studio + Xcode
# More control over native code`}
                </code>
              </div>
              <p>✅ More control<br/>✅ Can use native modules<br/>⚠️ Steeper learning curve</p>
            </div>

            <div className="guide-card">
              <h3>Detailed Comparison</h3>
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Expo</th>
                    <th>React Native CLI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Setup Time</td>
                    <td>Minutes</td>
                    <td>Hours (tools config)</td>
                  </tr>
                  <tr>
                    <td>Native Code</td>
                    <td>Limited</td>
                    <td>Full access</td>
                  </tr>
                  <tr>
                    <td>Learning Curve</td>
                    <td>Easy</td>
                    <td>Difficult</td>
                  </tr>
                  <tr>
                    <td>Performance</td>
                    <td>Good</td>
                    <td>Better</td>
                  </tr>
                  <tr>
                    <td>Custom Modules</td>
                    <td>Hard</td>
                    <td>Easy</td>
                  </tr>
                  <tr>
                    <td>App Size</td>
                    <td>Larger</td>
                    <td>Smaller</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="guide-card">
              <h3>Which Should You Choose?</h3>
              <p><strong>Choose Expo if:</strong></p>
              <ul>
                <li>You're learning React Native</li>
                <li>You want quick development</li>
                <li>You don't need custom native modules</li>
              </ul>
              <p><strong>Choose React Native CLI if:</strong></p>
              <ul>
                <li>You need custom native code</li>
                <li>You're building production apps</li>
                <li>You need maximum performance</li>
              </ul>
            </div>
          </div>
        );

      case "project-structure":
        return (
          <div className="guide-section">
            <h2>Project Structure</h2>
            <div className="guide-card">
              <h3>Expo Project Structure</h3>
              <div className="code-block">
                <code>
                  {`MyApp/
├── assets/
│   └── images/        # App images and assets
├── node_modules/      # Dependencies
├── App.js            # Main entry point
├── app.json          # App configuration
├── package.json      # Project dependencies
├── package-lock.json
└── .gitignore        # Git ignore rules`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Key Files Explained</h3>
              <ul>
                <li><strong>App.js</strong> - Your main component. This is where your app starts</li>
                <li><strong>app.json</strong> - Configuration file for your app (name, version, splash screen)</li>
                <li><strong>package.json</strong> - Lists all dependencies and scripts</li>
                <li><strong>assets/</strong> - Store images, fonts, and other assets here</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Better Project Structure (Recommended)</h3>
              <div className="code-block">
                <code>
                  {`MyApp/
├── assets/
│   ├── images/
│   └── fonts/
├── src/
│   ├── screens/        # Screen components
│   │   ├── HomeScreen.js
│   │   └── DetailsScreen.js
│   ├── components/     # Reusable components
│   │   ├── Button.js
│   │   └── Card.js
│   ├── navigation/     # Navigation setup
│   │   └── RootNavigator.js
│   ├── utils/          # Helper functions
│   │   └── helpers.js
│   └── styles/         # Global styles
│       └── colors.js
├── App.js
├── app.json
└── package.json`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>App.json Configuration Example</h3>
              <div className="code-block">
                <code>
                  {`{
  "expo": {
    "name": "My React Native App",
    "slug": "my-app",
    "version": "1.0.0",
    "assetBundlePatterns": [
      "**/*"
    ],
    "ios": {
      "supportsTabletMode": true
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png"
      }
    }
  }
}`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Best Practices</h3>
              <ul>
                <li>✓ Keep components in separate files</li>
                <li>✓ Use descriptive file names</li>
                <li>✓ Organize by feature/screen</li>
                <li>✓ Keep assets organized by type</li>
                <li>✓ Extract reusable logic into utils</li>
              </ul>
            </div>
          </div>
        );

      case "rn-components":
        return (
          <div className="guide-section">
            <h2>React Native Components</h2>
            <div className="guide-card">
              <h3>What are Components?</h3>
              <p>
                Components are building blocks of React Native apps. They're reusable pieces of UI that encapsulate structure, style, and behavior.
              </p>
            </div>

            <div className="guide-card">
              <h3>Core Components</h3>
              <ul>
                <li><strong>View</strong> - Container for layout (like div in web)</li>
                <li><strong>Text</strong> - Display text (like p/span in web)</li>
                <li><strong>Image</strong> - Display images</li>
                <li><strong>ScrollView</strong> - Scrollable container</li>
                <li><strong>FlatList</strong> - Efficient list rendering</li>
                <li><strong>TextInput</strong> - Text input field</li>
                <li><strong>Button</strong> - Pressable button</li>
                <li><strong>TouchableOpacity</strong> - Touchable button with opacity effect</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Basic Component Example</h3>
              <div className="code-block">
                <code>
                  {`import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export default function MyComponent() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Hello React Native!</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>View Component</h3>
              <p>The fundamental building block for React Native UI. Like a &lt;div&gt; in web.</p>
              <div className="code-block">
                <code>
                  {`import { View, StyleSheet } from 'react-native';

<View style={styles.container}>
  <View style={styles.box1} />
  <View style={styles.box2} />
</View>

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  box1: {
    backgroundColor: 'blue',
    height: 100,
    marginBottom: 10,
  },
  box2: {
    backgroundColor: 'red',
    height: 100,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Text Component</h3>
              <p>Display text on the screen.</p>
              <div className="code-block">
                <code>
                  {`import { Text, StyleSheet } from 'react-native';

<Text style={styles.heading}>Main Title</Text>
<Text style={styles.paragraph}>
  This is a paragraph of text
</Text>

const styles = StyleSheet.create({
  heading: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#333',
  },
  paragraph: {
    fontSize: 16,
    color: '#666',
    lineHeight: 24,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Image Component</h3>
              <p>Display images from local or remote sources.</p>
              <div className="code-block">
                <code>
                  {`import { Image, StyleSheet } from 'react-native';

// Local image
<Image
  source={require('./assets/my-image.png')}
  style={styles.image}
/>

// Remote image
<Image
  source={{ uri: 'https://example.com/image.png' }}
  style={styles.image}
/>

const styles = StyleSheet.create({
  image: {
    width: 200,
    height: 200,
    borderRadius: 10,
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "scrollview":
        return (
          <div className="guide-section">
            <h2>ScrollView</h2>
            <div className="guide-card">
              <h3>What is ScrollView?</h3>
              <p>
                ScrollView is a scrollable container that can hold multiple components and views. It's perfect when your content exceeds the screen height.
              </p>
            </div>

            <div className="guide-card">
              <h3>Basic Usage</h3>
              <div className="code-block">
                <code>
                  {`import { ScrollView, View, Text, StyleSheet } from 'react-native';

export default function ScrollViewExample() {
  return (
    <ScrollView style={styles.container}>
      <Text style={styles.header}>Scrollable Content</Text>
      
      {[...Array(10)].map((_, i) => (
        <View key={i} style={styles.item}>
          <Text>Item {i + 1}</Text>
        </View>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
  },
  header: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  item: {
    backgroundColor: '#e0e0e0',
    padding: 15,
    marginBottom: 10,
    borderRadius: 8,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Horizontal ScrollView</h3>
              <div className="code-block">
                <code>
                  {`import { ScrollView, View, StyleSheet } from 'react-native';

<ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
  {[...Array(5)].map((_, i) => (
    <View key={i} style={styles.horizontalItem} />
  ))}
</ScrollView>

const styles = StyleSheet.create({
  horizontalItem: {
    width: 100,
    height: 100,
    backgroundColor: 'blue',
    marginRight: 10,
    borderRadius: 8,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Common Props</h3>
              <ul>
                <li><strong>horizontal</strong> - Enable horizontal scrolling</li>
                <li><strong>scrollEnabled</strong> - Enable/disable scrolling</li>
                <li><strong>showsVerticalScrollIndicator</strong> - Show scroll indicator</li>
                <li><strong>onScroll</strong> - Callback when scrolling</li>
                <li><strong>contentContainerStyle</strong> - Style the scroll content</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>When to Use ScrollView</h3>
              <ul>
                <li>✅ Small to medium content</li>
                <li>✅ Static lists</li>
                <li>❌ Large lists (use FlatList instead)</li>
              </ul>
            </div>
          </div>
        );

      case "flatlist":
        return (
          <div className="guide-section">
            <h2>FlatList</h2>
            <div className="guide-card">
              <h3>What is FlatList?</h3>
              <p>
                FlatList is the recommended component for rendering large lists of data. It's more efficient than ScrollView as it only renders visible items.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# FlatList is built into React Native
# No installation needed, just import it
import { FlatList } from 'react-native';`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Basic Usage</h3>
              <div className="code-block">
                <code>
                  {`import { FlatList, View, Text, StyleSheet } from 'react-native';

const DATA = [
  { id: '1', title: 'Item 1' },
  { id: '2', title: 'Item 2' },
  { id: '3', title: 'Item 3' },
];

export default function FlatListExample() {
  return (
    <FlatList
      data={DATA}
      keyExtractor={(item) => item.id}
      renderItem={({ item }) => (
        <View style={styles.item}>
          <Text style={styles.title}>{item.title}</Text>
        </View>
      )}
    />
  );
}

const styles = StyleSheet.create({
  item: {
    backgroundColor: '#f0f0f0',
    padding: 15,
    marginHorizontal: 10,
    marginVertical: 5,
    borderRadius: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: '500',
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Advanced Example with Multiple Sections</h3>
              <div className="code-block">
                <code>
                  {`import { FlatList, View, Text } from 'react-native';

const DATA = [
  { id: '1', name: 'John', age: 25 },
  { id: '2', name: 'Jane', age: 28 },
  { id: '3', name: 'Bob', age: 30 },
];

<FlatList
  data={DATA}
  renderItem={({ item }) => (
    <View>
      <Text>{item.name}</Text>
      <Text>{item.age}</Text>
    </View>
  )}
  keyExtractor={(item) => item.id}
  ListHeaderComponent={
    <Text style={{ fontSize: 20, fontWeight: 'bold' }}>
      Users
    </Text>
  }
  ListFooterComponent={
    <Text>Total: {DATA.length} users</Text>
  }
  numColumns={2}
/>
`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Important Props</h3>
              <ul>
                <li><strong>data</strong> - Array of items to render</li>
                <li><strong>renderItem</strong> - Function to render each item</li>
                <li><strong>keyExtractor</strong> - Function to get unique key for each item</li>
                <li><strong>numColumns</strong> - Number of columns (grid layout)</li>
                <li><strong>horizontal</strong> - Horizontal scrolling</li>
                <li><strong>onEndReached</strong> - Callback when reaching end (infinite scroll)</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Infinite Scroll Example</h3>
              <div className="code-block">
                <code>
                  {`import { FlatList, View, Text, ActivityIndicator } from 'react-native';
import { useState } from 'react';

const [data, setData] = useState([...Array(10)].map((_, i) => ({
  id: i.toString(),
  title: \`Item \${i + 1}\`
})));

const handleEndReached = () => {
  setData([
    ...data,
    ...[...Array(10)].map((_, i) => ({
      id: (data.length + i).toString(),
      title: \`Item \${data.length + i + 1}\`
    }))
  ]);
};

<FlatList
  data={data}
  renderItem={({ item }) => <Text>{item.title}</Text>}
  keyExtractor={(item) => item.id}
  onEndReached={handleEndReached}
  ListFooterComponent={<ActivityIndicator />}
/>`}
                </code>
              </div>
            </div>
          </div>
        );

      case "buttons":
        return (
          <div className="guide-section">
            <h2>Button and Touchable Components</h2>
            <div className="guide-card">
              <h3>Overview</h3>
              <p>
                React Native provides several ways to make components respond to touches. The most common are Button, TouchableOpacity, TouchableHighlight, and TouchableWithoutFeedback.
              </p>
            </div>

            <div className="guide-card">
              <h3>Basic Button</h3>
              <div className="code-block">
                <code>
                  {`import { Button, Alert, View } from 'react-native';

<Button
  title="Press Me"
  onPress={() => Alert.alert('Button Pressed!')}
  color="#2196F3"
/>
`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>TouchableOpacity (Best for Custom Styling)</h3>
              <div className="code-block">
                <code>
                  {`import { TouchableOpacity, Text, StyleSheet } from 'react-native';

<TouchableOpacity 
  style={styles.button}
  onPress={() => console.log('Pressed!')}
>
  <Text style={styles.buttonText}>Custom Button</Text>
</TouchableOpacity>

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>TouchableHighlight</h3>
              <p>Underlay color appears when pressed.</p>
              <div className="code-block">
                <code>
                  {`import { TouchableHighlight, Text } from 'react-native';

<TouchableHighlight
  onPress={() => console.log('Pressed!')}
  underlayColor="#DDDDDD"
>
  <Text>Press me</Text>
</TouchableHighlight>`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>All Touch Props</h3>
              <ul>
                <li><strong>onPress</strong> - Called when pressed</li>
                <li><strong>onLongPress</strong> - Called for long press</li>
                <li><strong>onPressIn</strong> - Called when finger touches down</li>
                <li><strong>onPressOut</strong> - Called when finger lifts up</li>
                <li><strong>disabled</strong> - Disable the component</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Complete Button Example</h3>
              <div className="code-block">
                <code>
                  {`import { TouchableOpacity, Text, View, StyleSheet } from 'react-native';
import { useState } from 'react';

export default function ButtonExample() {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={[
          styles.button,
          isPressed && styles.buttonPressed
        ]}
        onPress={() => setIsPressed(!isPressed)}
      >
        <Text style={styles.text}>
          {isPressed ? 'Pressed!' : 'Press Me'}
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    padding: 20,
  },
  button: {
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonPressed: {
    backgroundColor: '#0051CC',
  },
  text: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "textinput":
        return (
          <div className="guide-section">
            <h2>TextInput Component</h2>
            <div className="guide-card">
              <h3>What is TextInput?</h3>
              <p>
                TextInput is a fundamental component for inputting text into the app via a keyboard. It's the equivalent of HTML's &lt;input&gt; tag.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# TextInput is built into React Native
import { TextInput } from 'react-native';`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Basic TextInput</h3>
              <div className="code-block">
                <code>
                  {`import { TextInput, View, StyleSheet } from 'react-native';
import { useState } from 'react';

export default function TextInputExample() {
  const [text, setText] = useState('');

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.input}
        placeholder="Enter your name"
        value={text}
        onChangeText={setText}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ddd',
    padding: 10,
    fontSize: 16,
    borderRadius: 8,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Different Input Types</h3>
              <div className="code-block">
                <code>
                  {`// Email input
<TextInput
  placeholder="Email"
  keyboardType="email-address"
  autoCapitalize="none"
/>

// Password input
<TextInput
  placeholder="Password"
  secureTextEntry={true}
/>

// Phone input
<TextInput
  placeholder="Phone"
  keyboardType="phone-pad"
/>

// Number input
<TextInput
  placeholder="Age"
  keyboardType="number-pad"
/>`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Common Props</h3>
              <ul>
                <li><strong>placeholder</strong> - Placeholder text</li>
                <li><strong>secureTextEntry</strong> - Hide text (for passwords)</li>
                <li><strong>keyboardType</strong> - Type of keyboard (email, number, phone)</li>
                <li><strong>autoCapitalize</strong> - Auto capitalize (none, sentences, words, characters)</li>
                <li><strong>maxLength</strong> - Max characters allowed</li>
                <li><strong>editable</strong> - Enable/disable editing</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Complete Form Example</h3>
              <div className="code-block">
                <code>
                  {`import { TextInput, View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useState } from 'react';

export default function FormExample() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = () => {
    console.log('Login:', email, password);
  };

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.input}
        placeholder="Email"
        keyboardType="email-address"
        value={email}
        onChangeText={setEmail}
      />

      <TextInput
        style={styles.input}
        placeholder="Password"
        secureTextEntry
        value={password}
        onChangeText={setPassword}
      />

      <TouchableOpacity
        style={styles.button}
        onPress={handleLogin}
      >
        <Text style={styles.buttonText}>Login</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    justifyContent: 'center',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ddd',
    padding: 12,
    marginBottom: 15,
    borderRadius: 8,
    fontSize: 16,
  },
  button: {
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "keyboard-view":
        return (
          <div className="guide-section">
            <h2>KeyboardAvoidingView</h2>
            <div className="guide-card">
              <h3>What is KeyboardAvoidingView?</h3>
              <p>
                KeyboardAvoidingView is a component that automatically adjusts its height or position when the keyboard appears, preventing it from overlapping with TextInput or other input elements.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# Built into React Native
import { KeyboardAvoidingView } from 'react-native';`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Basic Usage</h3>
              <div className="code-block">
                <code>
                  {`import { KeyboardAvoidingView, TextInput, View, Platform } from 'react-native';

<KeyboardAvoidingView
  behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
  style={{ flex: 1 }}
>
  <View style={{ flex: 1, justifyContent: 'flex-end' }}>
    <TextInput
      placeholder="Type here..."
      style={{
        borderWidth: 1,
        padding: 10,
        margin: 10,
        borderRadius: 8,
      }}
    />
  </View>
</KeyboardAvoidingView>`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Behavior Options</h3>
              <ul>
                <li><strong>height</strong> - Reduces the height of the view</li>
                <li><strong>position</strong> - Moves the view up</li>
                <li><strong>padding</strong> - Adds padding (iOS preferred)</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Complete Chat Form Example</h3>
              <div className="code-block">
                <code>
                  {`import { 
  KeyboardAvoidingView, 
  TextInput, 
  TouchableOpacity, 
  Text, 
  View, 
  Platform,
  StyleSheet 
} from 'react-native';
import { useState } from 'react';

export default function ChatForm() {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    console.log('Sending:', message);
    setMessage('');
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{ flex: 1 }}
    >
      <View style={styles.container}>
        <View style={styles.messageList}>
          {/* Messages would go here */}
        </View>

        <View style={styles.inputContainer}>
          <TextInput
            style={styles.input}
            placeholder="Type a message..."
            value={message}
            onChangeText={setMessage}
            multiline
          />
          <TouchableOpacity
            style={styles.sendButton}
            onPress={handleSend}
          >
            <Text style={styles.sendText}>Send</Text>
          </TouchableOpacity>
        </View>
      </View>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  messageList: {
    flex: 1,
    padding: 10,
  },
  inputContainer: {
    flexDirection: 'row',
    padding: 10,
    borderTopWidth: 1,
    borderTopColor: '#ddd',
  },
  input: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 20,
    paddingHorizontal: 15,
    paddingVertical: 8,
    marginRight: 10,
  },
  sendButton: {
    justifyContent: 'center',
    paddingHorizontal: 15,
  },
  sendText: {
    color: '#007AFF',
    fontWeight: 'bold',
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "flexbox":
        return (
          <div className="guide-section">
            <h2>Flexbox Layout</h2>
            <div className="guide-card">
              <h3>What is Flexbox?</h3>
              <p>
                Flexbox is a layout system used in React Native to arrange components in a flexible and responsive way. It's similar to CSS Flexbox.
              </p>
            </div>

            <div className="guide-card">
              <h3>Key Properties</h3>
              <ul>
                <li><strong>flex</strong> - Defines how much space a component takes</li>
                <li><strong>flexDirection</strong> - 'row' or 'column' (default: column)</li>
                <li><strong>justifyContent</strong> - Align items along main axis</li>
                <li><strong>alignItems</strong> - Align items along cross axis</li>
                <li><strong>gap</strong> - Space between items</li>
                <li><strong>flexWrap</strong> - Wrap items to next line</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Basic Example</h3>
              <div className="code-block">
                <code>
                  {`import { View, StyleSheet } from 'react-native';

<View style={styles.container}>
  <View style={styles.box1} />
  <View style={styles.box2} />
  <View style={styles.box3} />
</View>

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: 20,
  },
  box1: {
    width: 80,
    height: 80,
    backgroundColor: 'red',
  },
  box2: {
    width: 80,
    height: 80,
    backgroundColor: 'blue',
  },
  box3: {
    width: 80,
    height: 80,
    backgroundColor: 'green',
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Justify Content Values</h3>
              <ul>
                <li><strong>flex-start</strong> - Items at the start</li>
                <li><strong>flex-end</strong> - Items at the end</li>
                <li><strong>center</strong> - Items in center</li>
                <li><strong>space-between</strong> - Equal space between items</li>
                <li><strong>space-around</strong> - Equal space around items</li>
                <li><strong>space-evenly</strong> - Equal space everywhere</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Align Items Values</h3>
              <ul>
                <li><strong>flex-start</strong> - Items at start</li>
                <li><strong>flex-end</strong> - Items at end</li>
                <li><strong>center</strong> - Items centered</li>
                <li><strong>stretch</strong> - Items stretch to fill</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Complete Layout Example</h3>
              <div className="code-block">
                <code>
                  {`import { View, Text, StyleSheet } from 'react-native';

export default function FlexboxLayout() {
  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.headerText}>Header</Text>
      </View>

      {/* Main Content */}
      <View style={styles.content}>
        <View style={styles.item}>
          <Text>Item 1</Text>
        </View>
        <View style={styles.item}>
          <Text>Item 2</Text>
        </View>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <Text style={styles.footerText}>Footer</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
  header: {
    height: 60,
    backgroundColor: '#2196F3',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerText: {
    color: 'white',
    fontSize: 18,
    fontWeight: 'bold',
  },
  content: {
    flex: 1,
    padding: 10,
    gap: 10,
  },
  item: {
    flex: 1,
    backgroundColor: '#e0e0e0',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
  },
  footer: {
    height: 60,
    backgroundColor: '#333',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerText: {
    color: 'white',
    fontSize: 16,
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "safearea":
        return (
          <div className="guide-section">
            <h2>SafeAreaView</h2>
            <div className="guide-card">
              <h3>What is SafeAreaView?</h3>
              <p>
                SafeAreaView is a component that automatically adjusts its content to avoid overlapping with notches, dynamic islands, and other screen elements like status bars.
              </p>
            </div>

            <div className="guide-card">
              <h3>Why Use SafeAreaView?</h3>
              <p>
                Modern smartphones have notches, rounded corners, and other intrusions. SafeAreaView ensures your content is always visible and not hidden behind these elements.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# For Expo projects
npm install react-native-safe-area-context
expo install react-native-safe-area-context

# Or for React Native CLI
npm install react-native-safe-area-context`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Basic Usage</h3>
              <div className="code-block">
                <code>
                  {`import { SafeAreaView, View, Text, StyleSheet } from 'react-native';

export default function App() {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.text}>Safe Content</Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  content: {
    flex: 1,
    padding: 16,
  },
  text: {
    fontSize: 18,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Complete App Example</h3>
              <div className="code-block">
                <code>
                  {`import { SafeAreaView, View, Text, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function App() {
  const insets = useSafeAreaInsets();

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerText}>My App</Text>
      </View>

      <View style={styles.content}>
        <Text>Main Content Here</Text>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>Footer</Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  header: {
    backgroundColor: '#2196F3',
    padding: 16,
  },
  headerText: {
    color: 'white',
    fontSize: 20,
    fontWeight: 'bold',
  },
  content: {
    flex: 1,
    padding: 16,
  },
  footer: {
    backgroundColor: '#333',
    padding: 16,
  },
  footerText: {
    color: 'white',
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "safearea-statusbar":
        return (
          <div className="guide-section">
            <h2>SafeAreaView vs StatusBar</h2>
            <div className="guide-card">
              <h3>What's the Difference?</h3>
              <p>
                SafeAreaView handles notches and system UI, while StatusBar controls the appearance of the status bar (battery, time, signal icons).
              </p>
            </div>

            <div className="guide-card">
              <h3>SafeAreaView</h3>
              <p>Handles:</p>
              <ul>
                <li>✓ Notches and dynamic islands</li>
                <li>✓ Rounded corners</li>
                <li>✓ Home indicator spacing</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>StatusBar</h3>
              <p>Controls:</p>
              <ul>
                <li>✓ Status bar color</li>
                <li>✓ Icon style (light/dark)</li>
                <li>✓ Hidden/visible</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Using Both Together</h3>
              <div className="code-block">
                <code>
                  {`import { SafeAreaView, StatusBar, View, StyleSheet } from 'react-native';

export default function App() {
  return (
    <>
      <StatusBar 
        barStyle="light-content" 
        backgroundColor="#2196F3"
      />
      <SafeAreaView style={styles.container}>
        <View style={styles.header}>
          {/* Header content */}
        </View>
      </SafeAreaView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    backgroundColor: '#2196F3',
    height: 56,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>StatusBar Properties</h3>
              <ul>
                <li><strong>barStyle</strong> - 'light-content', 'dark-content'</li>
                <li><strong>backgroundColor</strong> - Status bar background color</li>
                <li><strong>hidden</strong> - Hide/show status bar</li>
                <li><strong>translucent</strong> - Make status bar translucent</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Best Practice</h3>
              <p>
                Always use SafeAreaView as your root component and StatusBar at the top level. This ensures your app respects system UI on all devices.
              </p>
            </div>
          </div>
        );

      case "stylesheet":
        return (
          <div className="guide-section">
            <h2>StyleSheet</h2>
            <div className="guide-card">
              <h3>What is StyleSheet?</h3>
              <p>
                StyleSheet is a React Native API for creating optimized style objects. It's similar to CSS-in-JS but optimized for mobile performance.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# Built into React Native
import { StyleSheet } from 'react-native';`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Basic Usage</h3>
              <div className="code-block">
                <code>
                  {`import { View, Text, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  text: {
    fontSize: 16,
    color: '#333',
  },
});

<View style={styles.container}>
  <Text style={styles.text}>Hello</Text>
</View>`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Why Use StyleSheet?</h3>
              <ul>
                <li>✅ Performance optimization</li>
                <li>✅ Valid style objects at compile time</li>
                <li>✅ Reusable styles</li>
                <li>✅ Better organization</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Common Styling Properties</h3>
              <ul>
                <li><strong>flex</strong> - Flexible sizing</li>
                <li><strong>width/height</strong> - Dimensions</li>
                <li><strong>padding/margin</strong> - Spacing</li>
                <li><strong>backgroundColor</strong> - Background color</li>
                <li><strong>borderRadius</strong> - Rounded corners</li>
                <li><strong>borderWidth/borderColor</strong> - Borders</li>
                <li><strong>shadowColor</strong> - Shadow effect</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Complete Styling Example</h3>
              <div className="code-block">
                <code>
                  {`import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

export default function StyledComponent() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Welcome</Text>
      
      <View style={styles.card}>
        <Text style={styles.cardText}>
          This is a styled card
        </Text>
      </View>

      <TouchableOpacity style={styles.button}>
        <Text style={styles.buttonText}>Press Me</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#f5f5f5',
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1c1c1c',
    marginBottom: 20,
  },
  card: {
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  cardText: {
    fontSize: 16,
    color: '#666',
    lineHeight: 24,
  },
  button: {
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
});`}
                </code>
              </div>
            </div>
          </div>
        );

      case "navigation-basics":
        return (
          <div className="guide-section">
            <h2>Navigation Basics</h2>
            <div className="guide-card">
              <h3>What is Navigation?</h3>
              <p>
                Navigation is how users move between different screens in your app. React Navigation is the most popular navigation library for React Native.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`# Install React Navigation
npm install @react-navigation/native

# Install dependencies
npm install react-native-screens react-native-safe-area-context

# Install the desired navigator
npm install @react-navigation/stack`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Navigation Types</h3>
              <ul>
                <li><strong>Stack Navigation</strong> - Screen stacking (most common)</li>
                <li><strong>Bottom Tab Navigation</strong> - Tab bar at bottom</li>
                <li><strong>Drawer Navigation</strong> - Side menu</li>
                <li><strong>Top Tab Navigation</strong> - Tabs at top</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Basic Setup with NavigationContainer</h3>
              <div className="code-block">
                <code>
                  {`import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

function HomeScreen({ navigation }) {
  return (
    <View>
      <Button
        title="Go to Details"
        onPress={() => navigation.navigate('Details')}
      />
    </View>
  );
}

function DetailsScreen() {
  return <View><Text>Details Screen</Text></View>;
}

export default function App() {
  return (
    <NavigationContainer>
      <Stack.Navigator>
        <Stack.Screen name="Home" component={HomeScreen} />
        <Stack.Screen name="Details" component={DetailsScreen} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Navigation Methods</h3>
              <ul>
                <li><strong>navigate()</strong> - Go to a screen</li>
                <li><strong>push()</strong> - Push a new instance</li>
                <li><strong>goBack()</strong> - Go back</li>
                <li><strong>reset()</strong> - Reset to home</li>
              </ul>
            </div>
          </div>
        );
case "Passing-Params":
  return (
    <div className="guide-section">
      <h2>Passing Parameters Between Screens</h2>

      <div className="guide-card">
        <h3>What is Passing Params?</h3>
        <p>
          In React Navigation, you can send data from one screen to another
          using <strong>route parameters</strong>. This is useful when you want
          to open a screen with specific information such as a user profile,
          product details, or an item from a list.
        </p>
      </div>

      <div className="guide-card">
        <h3>Basic Example</h3>

        <div className="code-block">
          <code>
{`// Screen A
function HomeScreen({ navigation }) {
  return (
    <Button
      title="Go to Profile"
      onPress={() =>
        navigation.navigate("Profile", {
          userId: 42,
          name: "John"
        })
      }
    />
  );
}`}
          </code>
        </div>
      </div>

      <div className="guide-card">
        <h3>Receiving Parameters</h3>

        <div className="code-block">
          <code>
{`// Screen B
function ProfileScreen({ route }) {
  const { userId, name } = route.params;

  return (
    <View>
      <Text>User ID: {userId}</Text>
      <Text>Name: {name}</Text>
    </View>
  );
}`}
          </code>
        </div>

        <p>
          The <strong>route.params</strong> object contains all parameters that
          were passed while navigating.
        </p>
      </div>

      <div className="guide-card">
        <h3>Passing Params to an Existing Screen</h3>

        <div className="code-block">
          <code>
{`navigation.push("Profile", {
  userId: 55
});`}
          </code>
        </div>

        <p>
          The <strong>push()</strong> method creates a new instance of the
          screen even if it already exists in the stack.
        </p>
      </div>

      <div className="guide-card">
        <h3>Updating Params</h3>

        <div className="code-block">
          <code>
{`navigation.setParams({
  name: "Updated User"
});`}
          </code>
        </div>

        <p>
          This allows you to update parameters after the screen has already been opened.
        </p>
      </div>

      <div className="guide-card">
        <h3>Common Use Cases</h3>
        <ul>
          <li>Opening a product details page</li>
          <li>Passing a user ID to a profile screen</li>
          <li>Sending form data to the next screen</li>
          <li>Passing filters or search queries</li>
        </ul>
      </div>
    </div>
  );
      case "stack-navigation":
        return (
          <div className="guide-section">
            <h2>Stack Navigation</h2>
            <div className="guide-card">
              <h3>What is Stack Navigation?</h3>
              <p>
                Stack Navigation provides a way for your app to transition between screens where each new screen is placed on top of a stack. You can navigate backward from a screen like a web browser.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`npm install @react-navigation/stack
npm install @react-navigation/native
npm install react-native-screens react-native-safe-area-context`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Complete Stack Navigation Example</h3>
              <div className="code-block">
                <code>
                  {`import React from 'react';
import { View, Text, Button, StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

function HomeScreen({ navigation }) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Home Screen</Text>
      <Button
        title="Go to Details"
        onPress={() => navigation.navigate('Details')}
      />
    </View>
  );
}

function DetailsScreen({ navigation }) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Details Screen</Text>
      <Button
        title="Go Back"
        onPress={() => navigation.goBack()}
      />
    </View>
  );
}

export default function App() {
  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: '#2196F3',
          },
          headerTintColor: '#fff',
          headerTitleStyle: {
            fontWeight: 'bold',
          },
        }}
      >
        <Stack.Screen name="Home" component={HomeScreen} />
        <Stack.Screen name="Details" component={DetailsScreen} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 20,
  },
});`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Passing Parameters</h3>
              <div className="code-block">
                <code>
                  {`// Navigate with parameters
navigation.navigate('Details', { userId: 123 })

// Receive parameters
function DetailsScreen({ route }) {
  const { userId } = route.params;
  return <Text>User ID: {userId}</Text>;
}`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Stack Navigator Props</h3>
              <ul>
                <li><strong>screenOptions</strong> - Configure header and other options</li>
                <li><strong>initialRouteName</strong> - Starting screen</li>
                <li><strong>headerMode</strong> - How header appears</li>
              </ul>
            </div>
          </div>
        );

      case "drawer-navigation":
        return (
          <div className="guide-section">
            <h2>Drawer Navigation</h2>
            <div className="guide-card">
              <h3>What is Drawer Navigation?</h3>
              <p>
                Drawer Navigation provides a hidden side menu that can be swiped from the left edge or accessed via a menu button. Perfect for app menus and navigation.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`npm install @react-navigation/drawer
npm install react-native-gesture-handler react-native-reanimated`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Complete Drawer Example</h3>
              <div className="code-block">
                <code>
                  {`import React from 'react';
import { View, Text, Button } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createDrawerNavigator } from '@react-navigation/drawer';

const Stack = createNativeStackNavigator();
const Drawer = createDrawerNavigator();

function HomeScreen({ navigation }) {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Home Screen</Text>
      <Button
        title="Open Menu"
        onPress={() => navigation.openDrawer()}
      />
    </View>
  );
}

function ProfileScreen() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Profile Screen</Text>
    </View>
  );
}

function SettingsScreen() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Settings Screen</Text>
    </View>
  );
}

function DrawerNavigator() {
  return (
    <Drawer.Navigator
      screenOptions={{
        drawerActiveTintColor: '#2196F3',
        headerStyle: {
          backgroundColor: '#2196F3',
        },
        headerTintColor: '#fff',
      }}
    >
      <Drawer.Screen name="Home" component={HomeScreen} />
      <Drawer.Screen name="Profile" component={ProfileScreen} />
      <Drawer.Screen name="Settings" component={SettingsScreen} />
    </Drawer.Navigator>
  );
}

export default function App() {
  return (
    <NavigationContainer>
      <DrawerNavigator />
    </NavigationContainer>
  );
}`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Drawer Options</h3>
              <ul>
                <li><strong>drawerActiveTintColor</strong> - Active item color</li>
                <li><strong>drawerInactiveTintColor</strong> - Inactive item color</li>
                <li><strong>drawerLabelStyle</strong> - Label styling</li>
                <li><strong>drawerPosition</strong> - 'left' or 'right'</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Custom Drawer Content</h3>
              <div className="code-block">
                <code>
                  {`function CustomDrawerContent(props) {
  return (
    <View style={{ flex: 1, padding: 20 }}>
      <Text style={{ fontSize: 20, fontWeight: 'bold' }}>
        My App
      </Text>
      <DrawerItemList {...props} />
    </View>
  );
}

<Drawer.Navigator
  drawerContent={CustomDrawerContent}
>
  {/* Screens */}
</Drawer.Navigator>`}
                </code>
              </div>
            </div>
          </div>
        );

      case "tab-navigation":
        return (
          <div className="guide-section">
            <h2>Tab Navigation</h2>
            <div className="guide-card">
              <h3>What is Tab Navigation?</h3>
              <p>
                Tab Navigation displays multiple screens with tabs at the bottom (or top). It's perfect for apps with multiple main sections like Instagram, Spotify, etc.
              </p>
            </div>

            <div className="guide-card">
              <h3>Installation</h3>
              <div className="code-block">
                <code>
                  {`npm install @react-navigation/bottom-tabs
npm install @react-navigation/native react-native-screens react-native-safe-area-context`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Complete Tab Navigation Example</h3>
              <div className="code-block">
                <code>
                  {`import React from 'react';
import { View, Text } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from '@expo/vector-icons';

const Tab = createBottomTabNavigator();

function HomeScreen() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Home Screen</Text>
    </View>
  );
}

function ProfileScreen() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Profile Screen</Text>
    </View>
  );
}

function SettingsScreen() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Settings Screen</Text>
    </View>
  );
}

export default function App() {
  return (
    <NavigationContainer>
      <Tab.Navigator
        screenOptions={({ route }) => ({
          tabBarIcon: ({ focused, color, size }) => {
            let iconName;
            if (route.name === 'Home') {
              iconName = focused ? 'home' : 'home-outline';
            } else if (route.name === 'Profile') {
              iconName = focused ? 'person' : 'person-outline';
            } else if (route.name === 'Settings') {
              iconName = focused ? 'settings' : 'settings-outline';
            }
            return <Ionicons name={iconName} size={size} color={color} />;
          },
          tabBarActiveTintColor: '#2196F3',
          tabBarInactiveTintColor: 'gray',
        })}
      >
        <Tab.Screen name="Home" component={HomeScreen} />
        <Tab.Screen name="Profile" component={ProfileScreen} />
        <Tab.Screen name="Settings" component={SettingsScreen} />
      </Tab.Navigator>
    </NavigationContainer>
  );
}`}
                </code>
              </div>
            </div>

            <div className="guide-card">
              <h3>Tab Navigation Options</h3>
              <ul>
                <li><strong>tabBarActiveTintColor</strong> - Active tab color</li>
                <li><strong>tabBarInactiveTintColor</strong> - Inactive tab color</li>
                <li><strong>tabBarShowLabel</strong> - Show/hide labels</li>
                <li><strong>tabBarPosition</strong> - 'bottom' or 'top'</li>
                <li><strong>tabBarStyle</strong> - Custom tab bar styling</li>
              </ul>
            </div>

            <div className="guide-card">
              <h3>Combining Stack and Tab Navigation</h3>
              <div className="code-block">
                <code>
                  {`function HomeStackNavigator() {
  return (
    <Stack.Navigator>
      <Stack.Screen name="HomeList" component={HomeList} />
      <Stack.Screen name="Details" component={Details} />
    </Stack.Navigator>
  );
}

function App() {
  return (
    <NavigationContainer>
      <Tab.Navigator>
        <Tab.Screen name="Home" component={HomeStackNavigator} />
        <Tab.Screen name="Profile" component={ProfileScreen} />
      </Tab.Navigator>
    </NavigationContainer>
  );
}`}
                </code>
              </div>
            </div>
          </div>
        );

    case "UseFouceffect-and-Usecallback":
  return (
    <div className="guide-section">
      <h2>useFocusEffect with useCallback</h2>

      <div className="guide-card">
        <h3>Why use useFocusEffect?</h3>
        <p>
          In React Native apps that use React Navigation, screens usually stay
          mounted when navigating between them. Because of this, 
          <strong>useEffect may not run again when you return to a screen.</strong>
        </p>

        <p>
          To handle this situation, React Navigation provides
          <strong>useFocusEffect</strong>. It runs every time the screen comes
          into focus.
        </p>

        <p>
          It is normally wrapped inside <strong>useCallback</strong> so that the
          function reference stays stable and does not re-run unnecessarily.
        </p>
      </div>

      <div className="guide-card">
        <h3>Example</h3>

        <div className="code-block">
          <code>
{`import React, { useCallback } from 'react';
import { View, Text } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';

function HomeScreen() {

  useFocusEffect(
    useCallback(() => {
      console.log("Screen focused");

      // cleanup when screen leaves focus
      return () => {
        console.log("Screen unfocused");
      };
    }, [])
  );

  return (
    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
      <Text>Home Screen</Text>
    </View>
  );
}

export default HomeScreen;`}
          </code>
        </div>
      </div>

      <div className="guide-card">
        <h3>Common Use Cases</h3>
        <ul>
          <li>Refresh API data when returning to a screen</li>
          <li>Reload user profile after editing</li>
          <li>Update notifications or messages</li>
          <li>Run logic when a screen becomes active</li>
        </ul>
      </div>
    </div>
  );   default:
        return <div className="guide-section"><p>Content loading...</p></div>;
    }
  };

  return (
    <div className="app">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <h1 className="logo"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-activity"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg> React Native</h1>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
        </div>

        <div className="progress-section">
          <div className="progress-header">
            <span>Progress</span>
            <span className="progress-percent">{progressPercent}%</span>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progressPercent}%` }}
            ></div>
          </div>
          <div className="progress-stats">
            <div className="stat">
              <div className="stat-number">{completedCount}</div>
              <div className="stat-label">Completed</div>
            </div>
            <div className="stat">
              <div className="stat-number">{TOPICS.length - completedCount}</div>
              <div className="stat-label">Remaining</div>
            </div>
          </div>
        </div>

        <div className="search-box">
          <input
            type="text"
            placeholder="Search courses..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="topics-list">
          {Object.entries(sections).map(([section, topics]) => (
            <div key={section} className="section">
              <h3 className="section-title">{section}</h3>
              {topics.map((topic) => (
                <div
                  key={topic.id}
                  className={`topic-item ${
                    currentTopic === topic.id - 1 ? "active" : ""
                  } ${completed[topic.id] ? "completed" : ""}`}
                  onClick={() => setCurrentTopic(topic.id - 1)}
                >
                  <div className="topic-left">
                    <input
                      type="checkbox"
                      checked={completed[topic.id] || false}
                      onChange={() => toggleComplete(topic.id)}
                      onClick={(e) => e.stopPropagation()}
                      className="topic-checkbox"
                    />
                    <div className="topic-info">
                      <div className="topic-title">{topic.title}</div>
                      <div className="topic-meta">
                        <span className={`level ${topic.level.toLowerCase()}`}>
                          {topic.level}
                        </span>
                        <span className="duration">{topic.duration}</span>
                      </div>
                    </div>
                  </div>
                  {completed[topic.id] && <div className="checkmark">✓</div>}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <div className="content-header">
          <div className="header-left">
            <h1 className="content-title">{currentTopicData.title}</h1>
            <div className="header-meta">
              <span className={`level ${currentTopicData.level.toLowerCase()}`}>
                {currentTopicData.level}
              </span>
              <span className="divider">•</span>
              <span className="section-tag">{currentTopicData.section}</span>
              <span className="divider">•</span>
              <span className="duration">{currentTopicData.duration}</span>
            </div>
          </div>
          <button
            className={`btn-complete ${completed[currentTopicData.id] ? "completed" : ""}`}
            onClick={() => toggleComplete(currentTopicData.id)}
          >
            {completed[currentTopicData.id] ? "✓ Completed" : "Mark Complete"}
          </button>
        </div>

        {/* Video and Content */}
        <div className="content-area">
          <div className="lesson-layout">
            {currentTopicData.videoId && (
              <div className="video-wrapper">
                <iframe
                  className="video-frame"
                  title={`${currentTopicData.title} video`}
                  src={`https://www.youtube.com/embed/${currentTopicData.videoId}?controls=1&modestbranding=1&rel=0&showinfo=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            )}
            {currentTopicData.isGuide && (
              <GuideContent content={currentTopicData.content} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
